import httpClient from '../../httpClient';

/**
 * @typedef {Object} obj
 * @param {string} email - user email
 * @param {string} passwrod - user password
 * @param {string} inviteUser - inviateUser
 */
function userLogin({ email, password, inviteUser }) {
  return httpClient({
    url: '/user/login',
    method: 'POST',
    data: {
      email,
      password,
      inviteUser,
    },
  });
}

export default userLogin;
